import React from "react";

const AddressSection = ({ title = "Billing", address }) => {
    if (!address) return null; // Handle if address object is not passed

    return (
        <div className="flex flex-col">
            <div className="w-full p-4 pb-3 border border-b-0 border-ec-border rounded-tl-lg rounded-tr-lg">
                <h3 className="font-inter easycommerce-dashboard-order-section-title">
                    {title} Address
                </h3>
            </div>

            <div className="w-full h-full flex flex-col gap-1 p-4 pt-10 border border-ec-border rounded-bl-lg rounded-br-lg">
                <p className="pb-[3px] text-ec-body font-inter text-base leading-[26px] font-normal">
                    {address["first_name"] + " " ?? ""}
                    {address["last_name"] ?? ""}
                </p>
                <p className="pb-[3px] text-ec-body font-inter text-base leading-[26px] font-normal">
                    {address["email"] ?? ""}
                </p>
                <p className="pb-[3px] text-ec-body font-inter text-base leading-[26px] font-normal">
                    {address["phone"] ?? ""}
                </p>
                <p className="pb-[3px] text-ec-body font-inter text-base leading-[26px] font-normal">
                    {address["address_1"] ?? ""}
                    <br />
                    {address["address_2"] ?? ""}
                </p>
                <p className="pb-[3px] text-ec-body font-inter text-base leading-[26px] font-normal">
                    {address["city"] ?? ""}-{address["postcode"] ?? ""}
                </p>
                <p className="pb-[3px] text-ec-body font-inter text-base leading-[26px] font-normal">
                    {address["state"] ?? ""}
                </p>
                <p className="pb-[3px] text-ec-body font-inter text-base leading-[26px] font-normal">
                    {address["country"] ?? ""}
                </p>
                <p className="pb-[3px] text-ec-secondary font-inter text-base leading-[26px] font-normal">
                    {address["company"] ?? ""}
                </p>
            </div>
        </div>
    );
};

export default AddressSection;
